import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getUserData, logout } from './authenticationApi';
import { LOGIN_PATH, LOGOUT_PATH } from '../common/consts/paths';

export const useUser = () => {
  const queryClient = useQueryClient();
  const {
    data: user,
    isError,
    isLoading
  } = useQuery({
    queryKey: ['userData'],
    queryFn: getUserData
  });

  const onLogout = useCallback(async () => {
    void queryClient.removeQueries({ queryKey: ['userData'] });
    await logout();

    if (typeof window === 'undefined') return;

    const isWithinIframe = window.top && window.top !== window.self;
    if (isWithinIframe && window.top) {
      window.top.location.href = `${window.top.location.origin}${LOGOUT_PATH}?redirectTo=${window.top.location.pathname}${window.top.location.search}`;
    } else {
      const pathname = window.location.pathname;
      const searchParams = window.location.search;
      const redirectToUrl = `${pathname}${searchParams}`;
      const updatedParams = new URLSearchParams({ redirectTo: redirectToUrl });
      const newUrl = `${LOGOUT_PATH}?${updatedParams}`;
      window.location.href = newUrl;
    }
  }, [queryClient]);

  const onLogin = useCallback(() => {
    if (typeof window === 'undefined') return;

    const pathname = window.location.pathname;
    const searchParams = window.location.search;
    const redirectToUrl = `${pathname}${searchParams}`;
    const updatedParams = new URLSearchParams({ redirectTo: redirectToUrl });
    const newUrl = `${LOGIN_PATH}?${updatedParams}`;
    window.location.href = newUrl;
  }, []);

  return {
    isError,
    isLoading,
    onLogin,
    onLogout,
    user
  };
};
